import 'reflect-metadata';
import { container } from 'tsyringe';
import { CreateOrdeService } from './createorderService';
import { SaveCart } from '../cart/saveCart';
import { GetOrderStatusService } from './getOrderStatusService';
export const DependencyInjectioOrdersInfrastructure = () => {
    container.register("iCreateOrdeService", { useClass: CreateOrdeService });
    container.register("iSaveCart", { useClass: SaveCart });
    container.register("IGetOrderStatusService", { useClass: GetOrderStatusService });
};
export default DependencyInjectioOrdersInfrastructure;
